import util   from '../../common/AppUtil';

const ServerMode = 2;
const ApiCode = "report";

export default {
  
  execute: function(action,params) {
    return util.callServerPost(ServerMode,ApiCode,params,action);
  }
}
  


// WEBPACK FOOTER //
// ./src/api/bas/report.js